import { mutate } from 'swr'
import { useState } from 'react'
import { Delete_Exam_Attempts } from '@graphql/mutations'
import {
  Single_Book,
  Single_SchoolClass,
  Single_SchoolGroup,
  Single_Section,
} from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useContext } from 'react'
import { AppContext } from '@state/context'
import { SCHOOL_RESOURCE_TYPES, USER_ROLES } from '@helpers/constants'
import { getSectionByIdFromResource, keepScrollPosition } from '@helpers/exams'
import {
  setSelectedSchoolResourceForProgressInspection,
  setSelectedSectionForProgressInspection,
} from '@state/actions/appActions'

const useDeleteExamAttempts = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    app: {
      userRole,
      currentSection,
      currentEditBookObject,
      selectedSchoolResourceTypeForProgressInspection,
      selectedSchoolResourceForProgressInspection,
      selectedSectionForProgressInspection,
    },
  } = state

  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Delete_Exam_Attempts,
      // successMessage ? successMessage : 'Testförsök borttaget.',
      successMessage ? successMessage : null,
      errorMessage ? errorMessage : 'Nåt gick fel!',
      async () => {
        if (userRole === USER_ROLES.STUDENT && currentEditBookObject) {
          await keepScrollPosition(mutate, [
            Single_Book,
            currentEditBookObject.id,
          ]) // refetch current book
        }

        if (userRole !== USER_ROLES.STUDENT) {
          if (currentEditBookObject) {
            await mutate([Single_Book, currentEditBookObject.id]) // refetch current book
          }
          if (currentSection) {
            await mutate([Single_Section, currentSection.id]) // refetch single section
          }

          if (selectedSchoolResourceForProgressInspection) {
            if (
              selectedSchoolResourceTypeForProgressInspection ===
              SCHOOL_RESOURCE_TYPES.CLASS
            ) {
              const res = await mutate([
                Single_SchoolClass,
                selectedSchoolResourceForProgressInspection.id,
              ])

              if (res?.schoolClass) {
                dispatch(
                  setSelectedSchoolResourceForProgressInspection(
                    res.schoolClass
                  )
                )

                if (selectedSectionForProgressInspection) {
                  const updatedSection = getSectionByIdFromResource(
                    res.schoolClass,
                    selectedSectionForProgressInspection.id
                  )

                  if (updatedSection) {
                    dispatch(
                      setSelectedSectionForProgressInspection(updatedSection)
                    )
                  }
                }
              }
            }
            if (
              selectedSchoolResourceTypeForProgressInspection ===
              SCHOOL_RESOURCE_TYPES.GROUP
            ) {
              const res = await mutate([
                Single_SchoolGroup,
                selectedSchoolResourceForProgressInspection.id,
              ])

              if (res?.schoolGroup) {
                dispatch(
                  setSelectedSchoolResourceForProgressInspection(
                    res.schoolGroup
                  )
                )

                if (selectedSectionForProgressInspection) {
                  const updatedSection = getSectionByIdFromResource(
                    res.schoolGroup,
                    selectedSectionForProgressInspection.id
                  )

                  if (updatedSection) {
                    dispatch(
                      setSelectedSectionForProgressInspection(updatedSection)
                    )
                  }
                }
              }
            }
          }
        }
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useDeleteExamAttempts }
